import { CellValidState } from "./CellValidState";
import { TransSource } from "./TransSource";

export class RowValidState {
  /**
   * @type {Map<any, CellValidState>}
   */
  public columnMap: Map<any, CellValidState> = new Map();
  public valid: boolean = true;
  /**
   * hat die row einen transitiven Fehler?
   */
  public transValid: boolean = true;
  /**
   * @type {TransSource | null}
   */
  public transSource: TransSource | null = null;
}
